import { 
  registerMicroApps, 
  start, 
  RegistrableApp, 
  MicroAppStateActions 
} from 'qiankun'
import microApps from './apps'

/**
 * 微应用生命周期处理函数
 */
const lifeCycles = {
  beforeLoad: [
    (app: RegistrableApp<any>) => {
      console.log('[主应用] before load', app.name)
      return Promise.resolve()
    }
  ],
  beforeMount: [
    (app: RegistrableApp<any>) => {
      console.log('[主应用] before mount', app.name)
      return Promise.resolve()
    }
  ],
  afterMount: [
    (app: RegistrableApp<any>) => {
      console.log('[主应用] after mount', app.name)
      return Promise.resolve()
    }
  ],
  beforeUnmount: [
    (app: RegistrableApp<any>) => {
      console.log('[主应用] before unmount', app.name)
      return Promise.resolve()
    }
  ],
  afterUnmount: [
    (app: RegistrableApp<any>) => {
      console.log('[主应用] after unmount', app.name)
      return Promise.resolve()
    }
  ]
}

/**
 * 全局数据共享
 */
const getGlobalState = () => {
  return {
    // 全局共享数据，可从主应用传递给子应用
    user: {
      id: 0,
      name: '',
      token: ''
    },
    theme: 'light'
  }
}

// 初始化微应用
export const initMicroApps = () => {
  // 注册微应用
  registerMicroApps(microApps, lifeCycles as any)

  // 设置默认进入第一个子应用
  const { prefetch = true, sandbox = true } = {}

  // 启动微应用
  start({ prefetch, sandbox })
}

// 传递全局状态给子应用
export const getMicroAppStateActions = (): MicroAppStateActions => {
  // 初始化全局状态
  const globalState = getGlobalState()
  
  // 应用间通信
  return {
    onGlobalStateChange(callback, immediate) {
      if (immediate) {
        callback(globalState, {})
      }
    },
    setGlobalState(state: any) {
      Object.assign(globalState, state)
      return true
    }
  } as MicroAppStateActions & { getGlobalState(): any }
} 